<greco-smart-img
  id="avatar-img"
  [src]="user?.photoURL || 'assets/lf3/icon_square_pad.png'"
  round
  border
  borderColor="primary"
></greco-smart-img>
<div class="user-status" *ngIf="showOnlineStatus"></div>
